/* @flow */
import * as React from 'react';

import CopySubscriberDialog from 'groups/components/CopySubscriberDialog';
import Glyph from 'components/Glyph';
import MenuItem from 'components/MenuItem';
import Relationship from 'entities/Relationship';
import { mountModal } from 'lib/modal';
import { promiseRelationship } from 'chat/utils/ChatPromises';
import errorLogger from 'utils/errorLogger';

type Props = {
  subscriberId: number,
  eventElementName: string,
  disabled: boolean,
  children: string,
};

class SubscribeUserMenuItem extends React.Component<Props> {
  static defaultProps = {
    children: 'Add to another class',
  };

  clickCopyDialog = () => {
    promiseRelationship(this.props.subscriberId)
      .then(relationship => {
        this.renderCopyDialog(relationship);
      })
      .catch(errorLogger('SubscribeUserMenuItem clickCopyDialog failed'));
  };

  renderCopyDialog = (relationship: Relationship) => {
    mountModal(<CopySubscriberDialog relationships={[relationship]} />, this);
  };

  render() {
    const { children, disabled, eventElementName } = this.props;

    return (
      <MenuItem
        onClick={this.clickCopyDialog}
        data-test-selector="subscribe-user-menu-item"
        eventElementName={eventElementName}
        disabled={disabled}>
        <Glyph name="plus" />
        <span>{children}</span>
      </MenuItem>
    );
  }
}

export default SubscribeUserMenuItem;
